import React from 'react';
import { Trophy, Info } from 'lucide-react';
import { renderStars } from '../../utils/renderStars';

export const LeaderboardTable = ({ data, domainKey, loading, solutionAreas, selectedArea, onAreaChange }) => {
  const medals = ['🥇', '🥈', '🥉'];
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        <button onClick={() => onAreaChange('all')} data-testid="lb-area-all"
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${selectedArea === 'all' ? 'bg-levelup-dark text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
          All Solutions
        </button>
        {solutionAreas.map(area => (
          <button key={area} onClick={() => onAreaChange(area)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${selectedArea === area ? 'bg-levelup-accent text-levelup-darker' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
            {area}
          </button>
        ))}
      </div>
      <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3 flex items-start gap-2 text-sm">
        <Info size={15} className="text-emerald-600 mt-0.5 flex-shrink-0" />
        <span className="text-emerald-800"><strong>How scores work:</strong> Score = Learners Trained + (Workshops Delivered × 3). Rewards both reach and delivery consistency.</span>
      </div>
      {loading ? (
        <div className="flex justify-center py-10"><div className="animate-spin w-8 h-8 border-4 border-levelup-accent border-t-transparent rounded-full" /></div>
      ) : data.length === 0 ? (
        <div className="text-center py-10 text-gray-500">
          <Trophy size={40} className="mx-auto mb-3 text-gray-300" />
          <p>No data available yet. Submit attendance reports to populate the leaderboard.</p>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-gray-200">
          <table className="w-full">
            <thead>
              <tr className="bg-levelup-dark text-white">
                <th className="px-3 py-2 text-left text-sm font-semibold">Rank</th>
                <th className="px-3 py-2 text-left text-sm font-semibold">Domain</th>
                <th className="px-3 py-2 text-left text-sm font-semibold">Learners Trained</th>
                <th className="px-3 py-2 text-left text-sm font-semibold">Workshops</th>
                <th className="px-3 py-2 text-left text-sm font-semibold">Last Training</th>
                <th className="px-3 py-2 text-left text-sm font-semibold">Score</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.map((item, idx) => (
                <tr key={item[domainKey] + idx} className={`${idx < 3 ? 'bg-amber-50' : 'hover:bg-gray-50'} transition-colors`}>
                  <td className="px-3 py-2 font-bold text-xl">
                    {item.rank <= 3 ? medals[item.rank - 1] : <span className="text-sm text-gray-500 ml-1">{item.rank}</span>}
                  </td>
                  <td className="px-3 py-2 font-semibold text-levelup-dark">{item[domainKey]}</td>
                  <td className="px-3 py-2"><span className="font-bold text-2xl text-levelup-teal">{item.learners_trained}</span></td>
                  <td className="px-3 py-2 text-gray-700">{item.workshops_count}</td>
                  <td className="px-3 py-2 text-gray-500 text-sm">{item.last_training || '—'}</td>
                  <td className="px-3 py-2">
                    <div className="flex items-center gap-1.5">
                      <div className="flex">{renderStars(item.stars)}</div>
                      <span className="font-bold text-gray-700 ml-1">{item.score}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
